export default "__VITE_ASSET__BHVvgg6E__"